import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useNavigate } from 'react-router-dom';
import A1 from '../Login/Chatbot.jpeg';
import axios from 'axios';

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });
 //rvapi.emedha.in
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [id]: type === 'checkbox' ? checked : value,
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Invalid email format';

    if (!formData.password.trim()) newErrors.password = 'Password is required';
    else if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setIsLoading(true);

      try {
        // Dummy login: PRK Nagaraju
        if (
          formData.email === 'prknagaraju@gmail.com' &&
          formData.password === 'prknagaraju@1234'
        ) {
          const userData = {
            id: "12",
            email: "fpservices@pnrfp.com",
            status: "approved",
            image: null,
            name: "PRK Nagaraju",
            phone: null,
            wa_id: "1850037658902050",
            p_id: "644195052118769",
            webhook_table: "prk_webhook",
            whatsappBusinessId: null,
            isActive: "0",
            flag: "0",
            resettoken: null,
            role: "user",
          };

          sessionStorage.setItem('user', JSON.stringify(userData));
          sessionStorage.setItem('password', formData.password);
          navigate('/dashboard');
        }
        // Dummy login: Admin
        else if (
          formData.email === 'admin@gmail.com' &&
          formData.password === 'admin@1234'
        ) {
          const adminData = {
            id: "1",
            email: "admin@gmail.com",
            status: "approved",
            name: "Admin User",
            role: "admin",
          };

          sessionStorage.setItem('user', JSON.stringify(adminData));
          sessionStorage.setItem('password', formData.password);
          navigate('/dashboard'); // You can change this to the appropriate admin route
        }
        // Actual backend login
        else {
          const response = await axios.post('https://botapi.emedha.in/auth/api/api/loginPage', formData);
          console.log(response.data);

          if (response.data.success) {
            const updatedUser = {
              ...response.data.user,
              role: response.data.role
            };

            sessionStorage.setItem("user", JSON.stringify(updatedUser));
            sessionStorage.setItem("password", formData.password);

            navigate('/dashboard');
          }

          else {
            setErrors({
              ...errors,
              password: response.data.message || 'Incorrect email or password, or account not approved.',
            });
          }
        }
      } catch (error) {
        setErrors({
          ...errors,
          password: 'Login failed. Please try again later.',
        });
        console.error('Login error:', error);
      }

      setIsLoading(false);
    } else {
      console.log('Validation failed');
    }
  };



  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f5f5f5', fontSize: '12px', fontFamily: '"Poppins", sans-serif' }}>
      <div style={{ width: '100%', maxWidth: '400px', backgroundColor: '#fff', padding: '30px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', borderRadius: '8px', }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img src={A1} alt="ChatBot Services" style={{ width: '150px', marginBottom: '20px' }} />
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#007bff' }}>
            Emedha ChatBot <span style={{ color: '#28a745' }}>Services</span>
          </h2>
          <p style={{ color: '#6c757d' }}>Welcome back! 👋</p>
          <p>Please sign in to access your account.</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="email" style={{ fontSize: '14px', fontWeight: '600', color: '#333', display: 'block', marginBottom: '5px' }}>EMAIL</label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" style={{ width: '100%', padding: '10px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '4px', outline: 'none', transition: 'border-color 0.3s', }} />
            {errors.email && <small style={{ color: '#e74c3c', fontSize: '12px' }}>{errors.email}</small>}
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="password" style={{ fontSize: '14px', fontWeight: '600', color: '#333', display: 'block', marginBottom: '5px' }}>PASSWORD</label>
            <input type="password" id="password" name="password" value={formData.password} onChange={handleChange} placeholder="Enter your password" style={{ width: '100%', padding: '10px', fontSize: '14px', border: '1px solid #ccc', borderRadius: '4px', outline: 'none', transition: 'border-color 0.3s', }} />
            {errors.password && <small style={{ color: '#e74c3c', fontSize: '12px' }}>{errors.password}</small>}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input type="checkbox" id="rememberMe" name="rememberMe" checked={formData.rememberMe} onChange={handleChange} style={{ marginRight: '5px' }} />
              <label htmlFor="rememberMe" style={{ fontSize: '14px', color: '#333' }}>Remember Me</label>
            </div>
            <a href="/forgot-password" style={{ color: '#007bff', fontSize: '12px', textDecoration: 'none' }}>Forgot Password?</a>
          </div>
          <button type="submit" style={{ width: '100%', padding: '12px', fontSize: '16px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', }} disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <p style={{ fontSize: '14px' }}>
            New on ChatBot Services?{' '}
            <Link to="/em-registation" style={{ color: '#007bff', textDecoration: 'none' }}>Create your free account</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
